export const WEATHER_ALERT_CACHE_KEY = 'weatherAlert';
export const WEATHER_ALERTS_LIST_CACHE_KEY = 'weatherAlerts';

export const WEATHER_ALERT_CACHE_TTL = 1000 * 60 * 5; // 5 minutes
